import { DateRange } from 'react-day-picker';
import { utcToZonedTime } from 'date-fns-tz';

export const utcDateRangeToZoned = (
  dateRange: DateRange | undefined,
  timeZone: string
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = dateRange.from
    ? utcToZonedTime(dateRange.from, timeZone)
    : undefined;
  const to = dateRange.to ? utcToZonedTime(dateRange.to, timeZone) : undefined;

  return { from, to };
};
